import { render, staticRenderFns } from "./ScrunchieMaterial.vue?vue&type=template&id=764d0a08&scoped=true"
import script from "./ScrunchieMaterial.vue?vue&type=script&lang=js"
export * from "./ScrunchieMaterial.vue?vue&type=script&lang=js"
import style0 from "./ScrunchieMaterial.vue?vue&type=style&index=0&id=764d0a08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d0a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764d0a08')) {
      api.createRecord('764d0a08', component.options)
    } else {
      api.reload('764d0a08', component.options)
    }
    module.hot.accept("./ScrunchieMaterial.vue?vue&type=template&id=764d0a08&scoped=true", function () {
      api.rerender('764d0a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/scrunchieArrangement/components/ScrunchieMaterial.vue"
export default component.exports